// Mini-carte des positions GPS CONSENTIES des visiteurs (demande du propriétaire
// 2026-10-10) : dernière position par IP, marqueurs dorés sur fond sombre —
// permission du navigateur requise, rien n'est enregistré sans consentement.
import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin } from "lucide-react";
import { api } from "../../lib/api";
import { fmtDateTimeMtl } from "../../lib/dateMtl";

const CENTRE = [46.8, -71.2];  // Québec

export default function CarteVisiteurs() {
  const [points, setPoints] = useState([]);
  const [pret, setPret] = useState(false);

  useEffect(() => {
    api.get("/admin/analytics/geo").then(({ data }) => setPoints(data.points || [])).catch(() => {});
  }, []);

  // Leaflet exige une taille connue : on monte la carte après le premier rendu
  useEffect(() => { setPret(true); }, []);

  return (
    <div className="bg-surface border border-ivory/10 rounded-xl p-5 mb-6" data-testid="carte-visiteurs">
      <p className="text-xs uppercase tracking-widest text-gold mb-1 flex items-center gap-2">
        <MapPin className="w-3.5 h-3.5" /> Carte des visiteurs
      </p>
      <p className="text-[11px] text-ivory/50 mb-4">
        Positions GPS exactes, partagées volontairement par les visiteurs (permission du navigateur) —
        90 derniers jours, un point par adresse IP.
      </p>
      {points.length === 0 ? (
        <p className="text-sm text-ivory/45 py-6 text-center" data-testid="carte-visiteurs-vide">
          Aucune position partagée pour l'instant — les points apparaîtront dès que des visiteurs
          accepteront la demande de localisation de leur navigateur.
        </p>
      ) : (
        <div className="carte-visiteurs-dark rounded-lg overflow-hidden border border-ivory/10" data-testid="carte-visiteurs-carte">
          {/* CARTO exige maintenant une CLÉ API (« API KEY REQUIRED » sur les
              tuiles — 2026-10-24) : bascule sur les tuiles OpenStreetMap
              standard (sans clé), assombries par filtre CSS pour garder
              l'esthétique sombre du tableau de bord */}
          <style>{`.carte-visiteurs-dark .leaflet-tile-pane { filter: invert(0.92) hue-rotate(180deg) brightness(0.95) contrast(0.88); }`}</style>
          {pret && (
            <MapContainer center={CENTRE} zoom={6} scrollWheelZoom={false}
              style={{ height: 320, width: "100%", background: "#0b0b10" }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {points.map((p, i) => (
                <CircleMarker key={`${p.ip}-${i}`} center={[p.lat, p.lng]} radius={7}
                  pathOptions={{ color: "#d4af37", fillColor: "#d4af37", fillOpacity: 0.65, weight: 1.5 }}>
                  <Popup>
                    <span style={{ fontSize: 12 }}>
                      <strong>{p.name || "Visiteur"}</strong><br />
                      IP : {p.ip}<br />
                      {p.last ? fmtDateTimeMtl(p.last) : ""}
                    </span>
                  </Popup>
                </CircleMarker>
              ))}
            </MapContainer>
          )}
        </div>
      )}
      {points.length > 0 && (
        <p className="text-[10px] text-ivory/40 mt-2" data-testid="carte-visiteurs-compte">
          {points.length} position{points.length > 1 ? "s" : ""} partagée{points.length > 1 ? "s" : ""} — cliquez un point pour le détail
        </p>
      )}
    </div>
  );
}
